import { render, staticRenderFns } from "./DigitCouplesForm.vue?vue&type=template&id=25862787&scoped=true&lang=pug&"
import script from "./DigitCouplesForm.vue?vue&type=script&lang=js&"
export * from "./DigitCouplesForm.vue?vue&type=script&lang=js&"
import style0 from "./DigitCouplesForm.vue?vue&type=style&index=0&id=25862787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25862787",
  null
  
)

export default component.exports